/**
 * `/klienci/zgloszenia` — „Zgłoszenia", the leads the public form produced. A wiring declaration.
 */

import { createFileRoute } from '@tanstack/react-router';

import { LeadsScreen } from '~/pages/public-form-leads';

export const Route = createFileRoute('/_shell/klienci/zgloszenia/')({
  component: LeadsScreen,
});
